// src/app/modules/Members/pages/members-table/column-formatters/AdaptiveMemberFormatter.jsx
// Adaptive formatter that shows different info based on member type

import React from "react";
import { User, ShieldCheck, Home, Building2 } from 'lucide-react';

export function AdaptiveMemberFormatter(cellContent, row, getLabel, hasFeature) {
  const user = row.user || {};
  const isStaff = hasFeature('hasStaff') && (row.member_type === 'staff' || row.role === 'security');

  let Icon = User;
  let bg = 'var(--purple-50)';
  let color = 'var(--purple-500)';

  if (isStaff) {
    Icon = ShieldCheck; bg = '#EFF6FF'; color = '#2563EB';
  } else if (hasFeature('hasResidents') && row.member_type === 'resident') {
    Icon = Home; bg = '#F0FDF4'; color = '#16a34a';
  } else if (row.role === 'admin' || row.role === 'manager') {
    Icon = Building2; bg = '#FFFBEB'; color = '#D97706';
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{
        width: 34, height: 34, borderRadius: '50%', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: bg, color,
      }}>
        <Icon size={16} />
      </div>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14, display: 'flex', alignItems: 'center', gap: 6 }}>
          {user.first_name} {user.last_name}
          {!user.first_name && !user.last_name && (row.invite_email || 'Pending')}
          {isStaff && row.staff_role && (
            <span className="sety-pill sety-pill-purple">{row.staff_role}</span>
          )}
        </div>

        {isStaff ? (
          <>
            {row.employee_id && <div className="sety-tbl-sub">ID: {row.employee_id}</div>}
            {row.is_supervisor && (
              <div className="sety-tbl-sub" style={{ color: '#2563EB', fontWeight: 600 }}>Supervisor</div>
            )}
          </>
        ) : (
          <>
            {hasFeature('hasResidents') && row.unit_number && (
              <div className="sety-tbl-sub">{getLabel('unit')} {row.unit_number}</div>
            )}
            {user.email && <div className="sety-tbl-sub">{user.email}</div>}
          </>
        )}
      </div>
    </div>
  );
}
